import React from 'react';
import BaseComponent from "../BaseComponent";
import InputText from "../../../appl/view/components/inputFields/InputText";
import DialogBase from "./DialogBase";
import PropTypes from "prop-types";
import HorizontalLayout from "../layouts/HorizontalLayout";
import CM from "../../../appl/model/system/CM";
import Checkbox from "../checkbox/Checkbox";
import Create from "../../../appl/model/service/campaign/dto/Create";
import {toast} from "react-toastify";
import InputSearchDropDown from "../../../appl/view/components/inputFields/dropdown/InputSearchDropDown";
import Upload from "../Upload";
import T from "../../../appl/model/system/text_translations/Translator";
import Button from "../../../appl/view/components/buttons/Button";
import LoadingButton from "@mui/lab/LoadingButton";

class DialogNewCampaign extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = {
      selectedTemplate: null,
      selectedDomain: null,
      newCampaignName: null,
      campaignDescription: null,
      allowAllUsers: false,
      uploadedThumbnail: null,
      isLoading: false,
    }

    this.domains = this.props.data.domains.map((domain) => {
      let domainId = domain['po2\\system\\db\\doctrine\\entity\\SysDomain#id'];
      let domainName = domain['po2\\system\\db\\doctrine\\entity\\SysDomain#name'];
      let item = {id: domainId, label: domainName};
      this.state.selectedDomain = this.state.selectedDomain || item;
      return item;
    });

    this.templates = this.props.data.templates.map((template) => {
      let templateId = template['appl\\models\\entity\\doctrine\\CampaignTemplate#id'];
      let templateName = template['appl\\models\\entity\\doctrine\\CampaignTemplate#name'];
      let item = {id: templateId, label: templateName};
      this.state.selectedTemplate = this.state.selectedTemplate || item
      return item;
    });
  }


  onSaveButtonClick(e) {
    this.setState({isLoading: true});
    let self = this;
    let createCampaign = new Create(this.state.selectedTemplate.id, this.state.newCampaignName,
      this.state.campaignDescription, this.state.selectedDomain.id, this.state.allowAllUsers,
      this.state.uploadedThumbnail);
    CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), createCampaign, function(response) {
      self.setState({isLoading: false});
      if (response.success) {
        toast.success('Campaign erfolgreich erstellt.');
        if (self.props.onSaveButtonClick) {
          self.props.onSaveButtonClick(e);
          self.props.onCloseButtonClick(e);
        }
      } else {
        toast.error('Campaign konnte nicht erstellt werden!\n' + response.message);
      }
    });
  }

  render() {
    let sortedTemplates = this.templates.sort((a, b) => a.label.localeCompare(b.label, 'de', { sensitivity: 'base' }));
    let sortedDomains = this.domains.sort((a, b) => a.label.localeCompare(b.label, 'de', { sensitivity: 'base' }));

    return <DialogBase
      title='Neue Campaign anlegen'
      onCloseButtonClick={this.props.onCloseButtonClick}
      maxWidth='md'
      actions={<>
        <Button disabled={this.state.isLoading}
                color=''
                size='large'
                onClick={this.props.onCloseButtonClick}
                variant='outlined'>
          {T.label_cancel()}
        </Button>
        <LoadingButton variant='contained'
                       loading={this.state.isLoading}
                       size='large'
                       onClick={(e) => this.onSaveButtonClick(e)}>
          {T.label_create()}
        </LoadingButton>
      </>}
    >
      <div className='grid grid-cols-12 gap-4'>
        <div className='col-span-full md:col-span-5 flex flex-col gap-4'>
          <InputText maxLength={28} labelElement='Campaign Name' onChange={(e) => this.state.newCampaignName = e.target.value}/>

          <InputSearchDropDown
            defaultValue={this.state.selectedTemplate}
            labelElement='Templateauswahl'
            onChange={(e, id, data) => this.setState({selectedTemplate: data})}
            disableClearable={true}>
            {sortedTemplates}
          </InputSearchDropDown>

          <InputSearchDropDown
            defaultValue={this.state.selectedDomain}
            labelElement='Domainauswahl'
            onChange={(e, id, data) => this.setState({selectedDomain: data})}
            disableClearable={true}>
            {sortedDomains}
          </InputSearchDropDown>

          <HorizontalLayout className='items-center gap-x-2'>
            <Checkbox
              labelElement='Zugriff für alle Benutzer'
              onChange={(e) => this.state.allowAllUsers = e.target.checked}/>
          </HorizontalLayout>
        </div>
        <div className='col-span-full md:col-span-7'>
          <InputText
            onChange={(e) => this.state.campaignDescription = e.target.value}
            multiline={true}
            minRows={7}
            labelElement='Beschreibung'/>
        </div>
        <div className='col-span-full gap-y-3 flex flex-col mt-8'>
          <Upload
            className='mb-12'
            title='Thumbnail hochladen'
            onUploadDone={(response) => this.onUploadDone(response)}
            dtoProperties={this.props.dtoProperties}/>
        </div>
      </div>
    </DialogBase>;
  }

  onUploadDone(response) {
    if (response.success) {
      this.state.uploadedThumbnail = response.data.fileUploadEntities[0].resourceId;
    } else {
      toast.error(response.message);
    }
  }

}

DialogNewCampaign.propTypes = {
  title: PropTypes.string, data: PropTypes.object, onCloseButtonClick: PropTypes.func, onSaveButtonClick: PropTypes.func
}
export default DialogNewCampaign;